import { useMemo } from 'react';

import { SM_MIN } from '@rover/kibble/styles/MediaQuery';
import useMatchMedia from '@rover/react-lib/src/hooks/useMatchMedia';
import { useStatsigClient } from '@rover/rsdk/src/modules/Statsig';

export type SearchByNameExperimentState = {
  isEnabled: boolean;
};

// getExperiment logs the exposure when called, so only read it on desktop — mweb can't render SbN.
export function useSearchByNameExperiment(): SearchByNameExperimentState {
  const isDesktop = useMatchMedia(`(min-width:${SM_MIN}px)`);
  // Depend on getExperiment, not client: only its identity changes when values update, so a
  // default read during async init is recomputed once the real values resolve.
  const { getExperiment } = useStatsigClient();

  // Memo guards the exposure side effect, keeping re-renders from re-firing getExperiment
  return useMemo(() => {
    if (!isDesktop) return { isEnabled: false };
    return { isEnabled: Boolean(getExperiment('search_by_name').get('is_enabled', false)) };
  }, [getExperiment, isDesktop]);
}
